// Externals
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Services
import * as shopService from '../services/shop';

// Types
import type { ShopList } from '../types/shop-list.model';
import { RecurringStatementItem } from 'src/types/recurring-statement-item.model';

export interface ShopState {
  list?: ShopList;
  recurringCosts?: RecurringStatementItem[];
}

const initialState: ShopState = {
  list: undefined,
  recurringCosts: undefined
};

export const fetchList = createAsyncThunk<
  { shopList: ShopList },
  { filters: { name: string }; skip: number; take: number }
>('shop/list', async ({ filters, skip, take }, thunkAPI) => {
  return await shopService.list({ filters, skip, take });
});

export const fecthRecurringCosts = createAsyncThunk<{ recurringItems: RecurringStatementItem[] }, { id: number }>(
  'shop/recurringCosts',
  async ({ id }, thunkAPI) => {
    return await shopService.getRecurringCosts({ id });
  }
);

const slice = createSlice({
  name: 'shop',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchList.fulfilled, (state, action): void => {
      state.list = action.payload.shopList;
    });
    builder.addCase(fetchList.rejected, (state, action): void => {
      state.list = undefined;
    });
    builder.addCase(fecthRecurringCosts.fulfilled, (state, action): void => {
      state.recurringCosts = action.payload.recurringItems;
    });
    builder.addCase(fecthRecurringCosts.rejected, (state, action): void => {
      state.recurringCosts = undefined;
    });
  }
});

export const { reducer } = slice;

export default slice;
